(function ($) {
  Drupal.behaviors.parallaxerFormatterV1 = {
    $window: $(window),
    $siteBanner: $(),
    attach: function (context) {
      var self = this;
      var $modules = $('.js-parallaxer-formatter', context);
      self.$siteBanner = $('.site-header__wrapper', context);
      var siteBannerHeight = 0;
      if (self.$siteBanner.length > 0) {
        siteBannerHeight = self.$siteBanner.height();
      }

      $.each($modules, function () {
        var $module = $(this);
        var $el;

        $el = self.initParallax($module);
        self.resize($module, $el, Number($module.data('distance')) / 1400);
      });

      if (window.location === window.parent.location) {
        self.$window.on('scroll', _.throttle(function () {
          var offsetYPage = window.scrollY;
          var pageHeight = self.$window.height();
          self.attachScroll(siteBannerHeight, offsetYPage, 0, pageHeight, $modules);
        }, 10));
      } else {
        $(window.parent).on('scroll', _.throttle(function () {
          const iframeWindow = this;
          var offsetYPage = iframeWindow.scrollY;
          var pageHeight =  $(iframeWindow).height();
          
          var iframeOffset  = $(window.parent.document).find('#' + window.frameElement.id)?.offset()?.top || 0;
          self.attachScroll(siteBannerHeight, offsetYPage, iframeOffset, pageHeight, $modules);
        }, 10));
      }
      self.$window.on('resize', _.throttle(function () {
        $.each($modules, function () {
          var $module = $(this);

          self.resize($module, $module.find('.js-parallax-init'));
        });
      }, 250));
    },
    attachScroll: function (siteBannerHeight, offsetYPage, iframeOffset, pageHeight, $modules) {
      var self = this;
      if (siteBannerHeight === 0) {
        siteBannerHeight = self.$siteBanner.height();
      }
      $.each($modules, function () {
        var $module = $(this);
        var $parallaxEl = $module.find('.js-parallax-init');
        var direction = $module.data('direction') ? $module.data('direction') : 'parallax-left';
        var offsetYEl = $module.offset().top + iframeOffset;
        var limit = offsetYEl - pageHeight;

        if (offsetYPage >= offsetYEl) {
          // Begin Parallax when element reaches top of the screen.
          self.resize($module, $parallaxEl);
        } else if (offsetYPage >= limit) {
          // Begin Parallax when element reaches bottom of the screen.
          self.setParallaxBottom($module, $parallaxEl, offsetYPage, limit, direction);
        }
      });
    },
    initParallax: function ($module) {
      var self = this;
      var $el;
      var direction = $module.data('direction') ? $module.data('direction') : 'parallax-left';
      var distance = Number($module.data('distance'));
      var elClassname = $module.data('el-classname');
      var initialDistance = (direction === 'parallax-left') ? -(distance) : distance;
      var isCarousel = $module.data('is-carousel');
      var customHeight = $module.data('el-height');

      if (elClassname) {
        $el = $($module.find('.' + elClassname).first());
      } else {
        $el = isCarousel ? $module.find('.slick-track').first() : this.setParallaxElement($module);
      }
      if (self.$window.scrollTop() < $el.offset().top) {
        $el.css('margin-left', initialDistance + 'px');
      }
      if (customHeight) {
        $module.height(customHeight);
      }
      $el.addClass('js-parallax-init');

      return $el;
    },
    setParallaxElement: function ($module) {
      var $paraEl;
      var $root = $module.find('.node-elc-nodeblock');
      var $container = $module.find('.js-parallaxer-formatter__container');

      if ($root && $root.length > 0) {
        $paraEl = $root.first().find('.content').children().first();
      } else {
        $paraEl = $($container.children(0));
      }

      return $paraEl;
    },
    resize: function ($module, $el, fullRatio) {
      var isCarousel = $module.data('is-carousel');
      var $resizeEl;

      if (fullRatio) {
        $module.data('ratio', fullRatio);
      }
      if (isCarousel) {
        $resizeEl = $module.find('.slick-initialized').first();
      } else {
        $resizeEl = $el;
      }

      if ($resizeEl && $resizeEl.length > 0) {
        $module.data('distance', $resizeEl.width() * Number($module.data('ratio')));
      }
    },
    setParallaxBottom: function ($module, $el, offsetYPage, limit, direction) {
      var elHeight = parseInt($module.css('height'), 10);
      var distance = Number($module.data('distance'));
      var currentPerc = (offsetYPage - limit) / elHeight;
      var speed = parseInt($module.data('speed'), 10) || 1;
      var currentDistance = 0;
      var newDistance = 0;
      if (currentPerc <= 1) {
        currentDistance = distance * currentPerc;
        newDistance = (direction === 'parallax-left') ? -(distance) + currentDistance : distance - currentDistance;

        if (speed > 0) {
          $el.css('margin-left', (newDistance / (1 / speed)) + 'px');
        } else {
          $el.css('margin-left', newDistance / Math.abs(speed) + 'px');
        }
      } else {
        
        $el.css('margin-left', '');
      }
    }
  };
})(jQuery);
